export interface ApplicationChangeLogEntry {
  questionId: string;
  applicationStatus: string;
  oldResponse: string | null;
  newResponse: string | null;
  changeLogDateTimeUtc: Date;
  userId: string;
  changeType: ChangeLogType;
  standardName?: string; // Optional field for standard name
}

export enum ChangeLogType {
  QuestionResponse = 1,
  ApplicationStatus = 2,
}
